import { useAuthenticator } from "@aws-amplify/ui-react";
import { Body } from "@indigo-components";

const SignInFooter = () => {
  const { toForgotPassword } = useAuthenticator();

  return (
    <div className="design-system-signin-footer">
      <button
        onClick={toForgotPassword}
        className="design-system-signin-link"
        type="button"
      >
        Forgot password?
      </button>
      <Body className="text-center mt-8 text-indigo-text-secondary" size="sm">
        By continuing, you agree to our{" "}
        <a
          href="https://www.getindigo.io/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-gray-500 hover:underline"
        >
          Privacy Policy
        </a>
      </Body>
    </div>
  );
};

export default SignInFooter;
